function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var NoticeOverlay = /*#__PURE__*/function () {
  function NoticeOverlay(app, mod) {
    _classCallCheck(this, NoticeOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(this.app, this.mod, false);
  }
  return _createClass(NoticeOverlay, [{
    key: "render",
    value: function render() {
      this.overlay.show(this.template());
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      try {
        document.querySelector('.notice_overlay').onclick = function () {
          _this.overlay.close();
        };
      } catch (err) {
        console.log(err);
      }
    }
  }, {
    key: "template",
    value: function template() {
      return "\n\t\t<div class=\"notice_overlay splash_overlay saitoa\">\n\t\t<h2>Two Player Settlers Variant</h2>\n\t\t<div>If you are familiar with the standard rules of Settlers, here are some changes to the two player version to make gameplay more fair and fun:</div>\n\t\t<ul class=\"notice-ul\">\n\t\t<li>longest road requires <em>6</em> road segments</li>\n\t\t<li>longest road worth only <em>1</em> victory point</li>\n\t\t<li><em>*NEW*</em> largest army worth only <em>1</em> victory point</li>\n\t\t<li>if a player is losing by 2 or more points, Robin Hood (the famous bandit) will come to their aid whenever a 7 is rolled.</li>\n\t\t</ul>\n\t\t</div>\n\t\t";
    }
  }]);
}();
module.exports = NoticeOverlay;